// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__PLtho","footer":"ModalInfo_footer__2Guww"};